export const APIKEY = 'AIzaSyAViK9eOILUQkMqOat2VIA_0FmQt4gAuO4'